import React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useTranslations } from 'components/utilities';

const CheckoutFramesLoader = ({ children }) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [isError, setIsError] = useState(false);

	const { t } = useTranslations();

	useEffect(() => {
		const scriptSrc = 'https://cdn.checkout.com/js/framesv2.min.js';
		const id = 'checkout_frames_script';

		const oldScript = document.getElementById(id);

		if (oldScript) {
			oldScript.remove();
		}

		const script = document.createElement('script');

		script.setAttribute('id', id);

		script.addEventListener('load', () => {
			setIsLoaded(true);
		});

		script.addEventListener('error', () => {
			script.remove();
			setIsError(true);
		});

		script.setAttribute('src', scriptSrc);

		document.head.appendChild(script);
	}, []);

	if (isError) {
		return <Alert severity="error">{t('errors.unknown')}</Alert>;
	}

	if (!isLoaded) {
		return <CircularProgress />;
	}

	return children;
};

CheckoutFramesLoader.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	])
};
export default CheckoutFramesLoader;
